import { FlexDetails } from 'ggApp/types/graphql';

import ActionTypes from './actionTypes';
import { Action } from './actions';

export const defaultState: SubscriptionDataStateType = null;

export type SubscriptionDataStateType = FlexDetails | null;

export default function reducer(
    state: SubscriptionDataStateType = defaultState,
    action: Action,
): SubscriptionDataStateType {
    if (action.type === ActionTypes.SET_SUBSCRIPTION_DATA) {
        return action.payload;
    }
    return state;
}
